(function () {
  let mainContentContainer = document.querySelector(".js-main-container");
  if (mainContentContainer) {
    let header = document.querySelector("#pageheader.pageheader--enable-transparent");
    if (header) {
      header.classList.add("pageheader--transparent");
      header.classList.add("pageheader--transparent-permitted");
      document.querySelector("#shopify-section-header").classList.add("header__transparent");
    }
  }

  if (document.querySelector('.hoko-hero-banner')?.classList.contains('light')) {
    document.querySelector('#pageheader').classList.remove('dark')
    document.querySelector('#pageheader').classList.add('light')
  } else {
    document.querySelector('#pageheader').classList.add('dark')
    document.querySelector('#pageheader').classList.remove('light')
  }
})();

var readMoreWrapper = document.querySelectorAll('.readmore_desc')

readMoreWrapper.forEach(function (element) {
  var readmore = element.querySelector('.readmore');
  var readless = element.querySelector('.readless');
  var descriptionFull = element.querySelector('.product-description-full');
  var descriptionShort = element.querySelector('.product-description-short');
  if (readmore) {
    readmore.addEventListener("click", function (event) {
      event.preventDefault();
      descriptionFull.style.display = 'block';
      descriptionShort.style.display = 'none';
    });
  }

  if (readless) {
    readless.addEventListener("click", function (events) {
      events.preventDefault();
      descriptionFull.style.display = 'none';
      descriptionShort.style.display = 'block';
    });
  }
});

/**
 * ====================================================================
 * Product Page Sticky Bar Events
 * ====================================================================
 */

const stickyBarPdp = document.querySelector(".js--sticky-wrapper");
if (stickyBarPdp) {
  if (window.innerWidth > 768) {
    window.addEventListener("scroll", function (e) {
      let mainProductTopHeight = (document.querySelector(".main-product__top .buy-buttons-row").offsetTop + document.querySelector(".main-product__top .buy-buttons-row").offsetHeight) + (document.querySelector("#shopify-section-header").offsetHeight + document.querySelector("#shopify-section-header").offsetTop) + (document.querySelector("#shopify-section-announcement-bar").offsetHeight);

      if ($(document).find(".section-special-product-banner").length) {
        if (window.innerWidth > 767) {
          mainProductTopHeight = (document.querySelector(".section-special-product-banner").offsetHeight) - (document.querySelector("#shopify-section-header").offsetHeight - document.querySelector("#shopify-section-announcement-bar").offsetHeight + 200);
        }
        else {
          mainProductTopHeight = (document.querySelector(".section-special-product-banner").offsetHeight) - (document.querySelector("#shopify-section-header").offsetHeight - document.querySelector("#shopify-section-announcement-bar").offsetHeight + 100);
        }
      } else {
        mainProductTopHeight = (document.querySelector(".main-product__top .buy-buttons-row").offsetTop + document.querySelector(".main-product__top .buy-buttons-row").offsetHeight) + 550;
      }
      if (window.pageYOffset >= mainProductTopHeight) {
        stickyBarPdp.classList.add("is-sticky");
        // document.querySelector('.template-product .section-main-product .product__sticky .product_variant .main-product-input-row').appendChild(document.querySelector('.template-product .section-main-product .product-detail .product-form .option-selectors'));
      } else {
        stickyBarPdp.classList.remove("is-sticky");
        // document.querySelector('.template-product .section-main-product .detail .main-product-input-row').appendChild(document.querySelector('.template-product .section-main-product .product-detail .product-form .option-selectors'));
      }

    });
  } else {
    stickyBarPdp.classList.add("is-sticky");
    // document.querySelector('.template-product .section-main-product .product__sticky .product_variant .main-product-input-row').appendChild(document.querySelector('.template-product .section-main-product .product-detail .product-form .option-selectors').cloneNode(true));
    // stickyBarPdp.querySelector('button.button-primary').classList.add('open-variant')
  }
}

/**
 * ====================================================================
 * File input Field
 * ====================================================================
 */

let fileInputs = document.querySelectorAll(".js-file-input");
let fileSelects = document.querySelectorAll(".js-file-selector");
if (fileSelects.length) {
  fileSelects.forEach((fileSelect) => {
    fileSelect.addEventListener("click", function (e) {
      e.currentTarget.closest(".js-block").querySelector(".js-file-input").click();
    });
  })
}

if (fileInputs.length) {
  fileInputs.forEach((fileInput) => {
    fileInput.addEventListener("change", function (e) {
      e.currentTarget.closest(".js-block").querySelector(".js-file-selector").value = e.currentTarget.value;
    });
  });
}

/*
 * ====================================================================
 * Announcement Bar
 * ====================================================================
 */
var announcementBar = document.getElementById('shopify-section-announcement-bar');
var announcementClose = document.querySelector('.announcement-bar__close');
document.documentElement.style.setProperty('--theme-announcement-bar', '91px');
announcementClose?.addEventListener("click", function (event) {
  announcementBar.classList.add('hidden');
  localStorage.setItem("announcementbar_hidden", "true");
  document.documentElement.style.setProperty('--theme-announcement-bar', '60px');
});


function Announcement() {
  var announcementText = announcementBar.querySelectorAll('.announcement__text_truncate');
  var windowWidth = window.innerWidth;

  announcementText.forEach((truncate) => {
    if ((truncate.clientWidth + 80) > windowWidth) {
      truncate.classList.add('truncate');
      truncate.nextElementSibling.addEventListener("click", function (event) {
        event.currentTarget.closest('.announcement__text').querySelector('.truncate').classList.add('open');
      });
    } else {
      truncate.classList.remove('truncate');
    }
  });
}

/*
 * ====================================================================
 * Subscription Button
 * ====================================================================
 */

var subscription = $('.button--subscription');
var subscriptionSection = $('.section-newsletter');
var footerSection = $('.section-footer');

if (subscriptionSection.length > 0) {
  var scrollSection = subscriptionSection;
} else {
  var scrollSection = footerSection;
}

subscription.on('click', function () {
  $('html,body').animate({
    scrollTop: scrollSection.offset().top - theme.stickyHeaderHeight()
  },
    1000);
  return false;
});

/*
 * ====================================================================
 * Contact Form
 * ====================================================================
 */
function Container() {
  var headerWidth = $('#pageheader .container');
  /*if (window.innerWidth > 1360) {*/
  document.documentElement.style.setProperty('--theme-container-offset', headerWidth.offset().left + 20 + 'px');
  /*}*/
}
function Contact() {
  var contactBlocks = $('.template-suffix-contact .contact_blocks');
  var contactInfo = $('.template-suffix-contact #template.reading-width');
  var headerWidth = $('#pageheader .container');

  if (window.innerWidth > 1700) {
    contactBlocks.css("margin-left", headerWidth.offset().left - 20);
    contactInfo.css("margin-right", window.innerWidth - (headerWidth.offset().left + headerWidth.innerWidth()));
  } else {
    contactBlocks.removeAttr('style');
    contactInfo.removeAttr('style');
  }
}
/*
 * ====================================================================
 * On window load and resize function call
 * ====================================================================
 */
window.onload = function () {
  Announcement();
  Contact();
  Container();

  // handleSpaceMenuToTop()
}
window.onresize = function () {
  Announcement();
  Contact();
  Container();

  // handleSpaceMenuToTop()
}



/*
 * ====================================================================
 * Video play on click
 * ====================================================================
 */
window.addEventListener('load', function () {
  document.querySelectorAll(".product-media.product-media--video video").forEach((e) => {
    e.addEventListener("click", function () {
      this.play();
    }, false);
  });
})

$(window).click(function () {
  $(window).trigger('scroll');
});

$(document).on('click', '#cart-summary-overlay', function (event) {
  event.stopPropagation();
});

/*
 * ====================================================================
 * Handle moble menu
 * ====================================================================
 */
(function () {
  const elmIconBar = document.querySelector('.logo-area__right__inner .icon-bar')
  const elmHtml = document.documentElement

  if (elmIconBar) {
    elmIconBar.addEventListener('click', function (e) {
      e.preventDefault()
      elmHtml.classList.add('open-mobile-menu')
    })
  }

  setTimeout(() => {
    const elmCloseMenu = document.querySelector('.icon-close-menu-mobile')
    const elmMenuLv1 = document.querySelectorAll('.navigation__tier-mobile .menulv1.navigation__item--with-children .navigation__link')

    if (elmCloseMenu) {
      elmCloseMenu.addEventListener('click', function (e) {
        e.preventDefault()
        elmHtml.classList.remove('open-mobile-menu')
      })
    }

    if (elmMenuLv1.length > 0) {
      for (const elm of elmMenuLv1) {
        elm.addEventListener('click', function () {
          const parentElm = elm.closest('li')
          const elmMenuContent = parentElm.querySelector('.menu-dropdown')
          elmMenuContent.style.height = 0

          if (elm.classList.contains('active')) {
            elm.classList.remove('active')
            elmMenuContent.style.height = 0
          } else {
            elm.classList.add('active')
            elmMenuContent.style.height = 'auto'
          }
        })
      }
    }
  }, 500)

  setTimeout(() => {
    $('#insta-feed .instafeed-new-layout-wrapper').owlCarousel({
      loop: false,
      margin: 8,
      nav: false,
      dots: false,
      lazyLoad: true,
      responsive: {
        0: {
          items: 2
        },
        768: {
          items: 7
        }
      }
    })
  }, 4000)
})()

let tmpData = []

$(document).ready(function () {
  const elmNavOverlayMobile = document.querySelector('.box-overlay')
  if (elmNavOverlayMobile) {
    elmNavOverlayMobile.addEventListener('click', function () {
      document.documentElement.classList.remove('open-mobile-menu')
    })
  }

  // Init owl Section Shop The Look
  const sectionShopTheLookSwiper = new Swiper('.hoko-shop-the-look__bottom-lists .swiper-shop-the-look', {
    loop: false,
    spaceBetween: 8,
    slidesPerView: 'auto',
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
    },
  })

  const elmBtnOpenPopupBundle = document.querySelector('.btn-open-shop-the-look')
  const elmPopupBundle = document.querySelector('.hoko-shop-the-look--bundles')
  const elmClosePopupOutside = document.querySelector('.box-overlay')
  const btnClosePopup = document.querySelector('.btn-close-popup--bundle')
  const listDetails = document.querySelectorAll('.hoko-shop-the-look--bundles-content .bundles--detail')
  const nextButtons = document.querySelectorAll('.hoko-shop-the-look--bundles-content .btn-next-step')
  const backButtons = document.querySelectorAll('.hoko-shop-the-look--bundles-content .btn-back-step')

  if (elmBtnOpenPopupBundle) {
    elmBtnOpenPopupBundle.addEventListener('click', function () {
      if (!elmPopupBundle) return
      elmPopupBundle.classList.add('active')

      document.documentElement.classList.add('popup-overlay')
      elmClosePopupOutside.classList.remove('hidden')
      resetPopup()

      initSelectedVariant()
    })
  }

  if (btnClosePopup) {
    btnClosePopup.addEventListener('click', function () {
      document.documentElement.classList.remove('popup-overlay')
      elmClosePopupOutside.classList.add('hidden')
      elmPopupBundle?.classList.remove('active')

      resetPopup()
    })
  }

  if (elmClosePopupOutside) {
    elmClosePopupOutside.addEventListener('click', function () {
      document.documentElement.classList.remove('popup-overlay')
      elmClosePopupOutside.classList.add('hidden')
      elmPopupBundle?.classList.remove('active')

      resetPopup()
    })
  }

  if (nextButtons.length > 0) {
    nextButtons.forEach((button, index) => {
      button.addEventListener('click', function () {
        listDetails[index].classList.remove('active')
        listDetails[index + 1].classList.add('active')
      })
    })
  }

  if (backButtons.length > 0) {
    backButtons.forEach((button, index) => {
      button.addEventListener('click', function () {
        listDetails[index + 1].classList.remove('active')
        listDetails[index].classList.add('active')
      })
    })
  }

  function initSelectedVariant() {
    const elmsSteps = document.querySelectorAll('product-step-custom')
    if (elmsSteps.length > 0) {
      elmsSteps.forEach(step => {
        const optionsColors = step.querySelectorAll('.option-selector--swatch input[type="radio"]')
        const optionsSizes = step.querySelectorAll('.option-selector:not(.option-selector--swatch) input[type="radio"]')
        const productData = JSON.parse(step.querySelector('script[type="application/json"]').textContent)
        const variants = productData.variants
        const firstAvailableVariant = variants.find(variant => variant.available)

        if (firstAvailableVariant) {
          const { option1: firstAvailableColor, option2: firstAvailableSize } = firstAvailableVariant
          const colorRadio = [...optionsColors].find(radio => radio.value === firstAvailableColor)

          if (colorRadio) {
            colorRadio.checked = true
          }

          const sizeRadio = [...optionsSizes].find(radio => radio.value === firstAvailableSize);
          if (sizeRadio) {
            sizeRadio.checked = true;
          }
        }
      })
    }
  }

  function resetPopup() {
    document.querySelectorAll('.option-selector input[type="radio"]').forEach(el => el.checked = false)
  }

  const elmPopupLoading = document.querySelector('.popup-loading')
  const elmNotifyMessage = document.querySelector('.notify-add-cart-successfully')
  // Handle submit mobile
  document.querySelector('.btn-submit-bundle')?.addEventListener('click', async (e) => {
    elmPopupLoading.classList.remove('hidden')
    e.preventDefault()
    const items = tmpData.map(selectedVariant => {
      return {
        id: selectedVariant.variant.id,
        quantity: 1
      }
    })

    if (items.length > 0) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        const data = await response.json()
        elmPopupLoading.classList.add('hidden')
        document.querySelector('.btn-close-popup--bundle').click()
        openMiniCart()
      } catch (error) {
        console.error(error)
      }
    }
  })

  // Handle submit desktop
  document.querySelector('.btn-submit-bundle-desktop')?.addEventListener('click', async (e) => {
    e.preventDefault()
    if (tmpData.length > 0) {
      // elmPopupLoading.classList.remove('hidden')
      const items = tmpData.map(selectedVariant => {
        return {
          id: selectedVariant.variant.id,
          quantity: 1
        }
      })

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        const data = await response.json()
        elmPopupLoading.classList.add('hidden')
        document.querySelector('.btn-close-popup--bundle').click()
        // open minicart after add to cart
        openMiniCart()
      } catch (error) {
        console.error(error)
      }
    }
  })

  // Init owl Section Product Type Collections
  const sectionProductTypeCollections = document.querySelector('.hoko-product-type')
  if (sectionProductTypeCollections) {
    new Swiper('.hoko-product-type__list .swiper', {
      loop: false,
      spaceBetween: 50,
      slidesPerView: 'auto',
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: sectionProductTypeCollections?.querySelector('.swiper-button-next'),
        prevEl: sectionProductTypeCollections?.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: sectionProductTypeCollections?.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
    })
  }

  // Init owl Section Product Type Collections
  const sectionCollectionLifestyle = document.querySelectorAll('.hoko-collection-lifestyle')
  if (sectionCollectionLifestyle.length > 0) {
    sectionCollectionLifestyle.forEach(section => {
      new Swiper(section.querySelector('.swiper'), {
        loop: false,
        spaceBetween: 8,
        slidesPerView: 'auto',
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: section?.querySelector('.swiper-button-next'),
          prevEl: section?.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: section?.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
      })
    })
  }

  // Init owl Section Product Type Collections
  const sectionGamaCryogenic = document.querySelector('.hoko-gama-cryogenic')
  if (sectionGamaCryogenic) {
    const sectionGamaCryogenicSwiper = new Swiper('.hoko-gama-cryogenic__list .swiper', {
      loop: false,
      spaceBetween: 8,
      slidesPerView: 1.3097,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: sectionGamaCryogenic?.querySelector('.swiper-button-next'),
        prevEl: sectionGamaCryogenic?.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: sectionGamaCryogenic?.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 4.3353,
          spaceBetween: 32,
        }
      },
    })
  }


  // Handle sticky button when scroll
  const addToCartButton = document.querySelector('.button-add-to-cart-here')
  if (addToCartButton) {
    // const buttonOffsetTop = addToCartButton.offsetTop
    const buttonOffsetTop = addToCartButton.getBoundingClientRect().top + window.pageYOffset;
    window.addEventListener('scroll', function () {
      if (window.scrollY > buttonOffsetTop) {
        document.querySelector('.template-product .section-main-product .product__sticky').classList.remove('hidden')
      } else {
        document.querySelector('.template-product .section-main-product .product__sticky').classList.add('hidden')
      }
    })
  }

  const btnCloseMessageNewletter = document.querySelector('.btn-close-message-newletter')
  if (btnCloseMessageNewletter) {
    btnCloseMessageNewletter.addEventListener('click', function () {
      document.documentElement.classList.remove('open-message-newletter')
      document.querySelector('.hoko-newletter__description--message').classList.add('hidden')
      document.querySelector('.hoko-newletter__description--content').classList.remove('hidden')
    })
  }
})

// Handle Popup Shop The Look
class ProductStepCustom extends HTMLElement {
  constructor() {
    super()

    this.productData = JSON.parse(this.querySelector('script[type="application/json"]').textContent)
    this.variants = this.productData.variants
    this.step = this.getAttribute('step')
    this.btnNextStep = this.querySelector('.btn-next-step')
    this.btnSubmit = this.querySelector('.btn-submit-bundle')
    this.inputs = this.querySelectorAll('.option-selector.option-selector--swatch input[type="radio"]')
  }

  connectedCallback() {
    this.optionsColors = this.querySelectorAll('.option-selector--swatch input[type="radio"]')
    this.optionsSizes = this.querySelectorAll('.option-selector:not(.option-selector--swatch) input[type="radio"]')
    this.optionsColors.forEach(selector => {
      selector.addEventListener('change', (selector) => {
        const valueOption = selector.target.value
        this.updateImageOptions(valueOption)
        this.updateSizeOptions()
        this.goToNextStep()
        this.checkSelection()
      })
    })

    this.optionsSizes.forEach(selector => {
      selector.addEventListener('change', (selector) => {
        this.checkSelection()
        this.goToNextStep()
      })
    })

    this.autoSelectAvailableOptions();
    this.goToNextStep()
  }

  updateImageOptions(valueOption) {
    const colors = this.variants.filter(variant => variant.option1 === valueOption)
    const colorSelected = colors[0]
    if (!colorSelected) return

    if (typeof colorSelected.featured_image !== 'undefined' && colorSelected.featured_image !== null) {
      const imageDOM = document.createElement('IMG')
      imageDOM.setAttribute('src', colorSelected.featured_image.src)
      imageDOM.setAttribute('loading', 'lazy')
      imageDOM.setAttribute('class', 'rimage__image fade-in cover lazyautosizes lazyloaded')
      imageDOM.setAttribute('data-aspectratio', 1.0)
      imageDOM.setAttribute('data-widths', '[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]')

      this.querySelector('.rimage-wrapper').innerHTML = ''
      this.querySelector('.rimage-wrapper').appendChild(imageDOM)
    }
  }

  updateSizeOptions() {
    const selectorColor = [...this.optionsColors].find(radio => radio.checked)?.value
    if (!selectorColor) return
    const availableSizes = this.variants.filter(variant => variant.option1 === selectorColor && variant.available).map(variant => variant.option2)

    this.optionsSizes.forEach(selector => {
      if (!availableSizes.includes(selector.value)) {
        selector.classList.add('is-unavailable')
      } else {
        selector.classList.remove('is-unavailable')
      }
    })

    if (availableSizes.length > 0) {
      const sizeRadio = [...this.optionsSizes].find(radio => radio.value === availableSizes[0]);
      if (sizeRadio) {
        sizeRadio.checked = true;
      }
    }
  }

  checkSelection() {
    const selectedColor = [...this.optionsColors].find(radio => radio.checked)?.value
    const selectedSize = [...this.optionsSizes].find(radio => radio.checked)?.value
    const selectedVariant = this.variants.find(variant => {
      return variant.option1 === selectedColor && variant.option2 === selectedSize && variant.available
    })

    if (selectedVariant) {
      if (tmpData[parseInt(this.getAttribute('step')) - 1] && tmpData[parseInt(this.getAttribute('step')) - 1].step.toString() === this.getAttribute('step').toString()) {
        tmpData[parseInt(this.getAttribute('step')) - 1]['variant'] = selectedVariant
      } else {
        tmpData.push({ step: this.getAttribute('step'), variant: selectedVariant })
      }
    } else {
      tmpData = tmpData.filter(i => parseInt(i.step) !== parseInt(this.getAttribute('step')))
      this.btnNextStep?.setAttribute('disabled', true)
    }
  }

  goToNextStep() {
    if ([...this.optionsColors].find(radio => radio.checked)?.value && [...this.optionsSizes].find(radio => radio.checked)?.value) {
      this.btnNextStep?.removeAttribute('disabled')
    } else {
      this.btnNextStep?.setAttribute('disabled', true)
    }
  }

  autoSelectAvailableOptions() {
    const firstAvailableVariant = this.variants.find(variant => variant.available)
    if (firstAvailableVariant) {
      const { option1: firstAvailableColor, option2: firstAvailableSize } = firstAvailableVariant
      const colorRadio = [...this.optionsColors].find(radio => radio.value === firstAvailableColor)
      if (colorRadio) {
        colorRadio.checked = true
      }
      this.updateSizeOptions();
      const sizeRadio = [...this.optionsSizes].find(radio => radio.value === firstAvailableSize);
      if (sizeRadio) {
        sizeRadio.checked = true;
      }
      this.checkSelection();
    }
  }
}

customElements.define('product-step-custom', ProductStepCustom)

class ProductStickyCustom extends HTMLElement {
  constructor() {
    super()

    this.productData = JSON.parse(this.querySelector('script[type="application/json"]').textContent)
    this.variants = this.productData.variants
  }

  connectedCallback() {
    this.optionsColors = this.querySelectorAll('.product__sticky .option-selector--swatch input[type="radio"]')
    this.optionsSizes = this.querySelectorAll('.product__sticky .option-selector:not(.option-selector--swatch) input[type="radio"]')
    this.inputVariantId = this.querySelector('.sticky-variant-id')

    this.optionsColors.forEach(selector => {
      selector.addEventListener('change', () => {
        this.updateSizeOptions()
      })
    })

    this.optionsSizes.forEach(selector => {
      selector.addEventListener('change', (selector) => {
        this.updateOptionsBySize()
      })
    })

    this.autoSelectAvailableOptions()
    this.handleActiveVariant()
    this.updateSizeOptions()
  }

  updateOptionsBySize() {
    const selectorColor = [...this.optionsColors].find(radio => radio.checked)?.value
    const selectorSize = [...this.optionsSizes].find(radio => radio.checked)?.value
    if (!selectorSize || !selectorColor) return
    const variant = this.findVariant(selectorColor, selectorSize)
    if (variant.available) {
      this.querySelector('.btn-add-to-cart-sticky').classList.remove('soldOut-text')
      this.querySelector('.btn-add-to-cart-sticky').removeAttribute('disabled')
      this.querySelector('.btn-add-to-cart-sticky').textContent = theme.strings.products_product_add_to_cart
      this.inputVariantId.setAttribute('value', variant.id)
    } else {
      this.querySelector('.btn-add-to-cart-sticky').classList.add('soldOut-text')
      this.querySelector('.btn-add-to-cart-sticky').setAttribute('disabled', true)
      this.querySelector('.btn-add-to-cart-sticky').textContent = theme.strings.products_variant_no_stock
    }
  }

  updateSizeOptions() {
    const selectorColor = [...this.optionsColors].find(radio => radio.checked)?.value
    const selectorSize = [...this.optionsSizes].find(radio => radio.checked)?.value
    if (!selectorColor) return
    const availableSizes = this.variants.filter(variant => variant.option1 === selectorColor && variant.available).map(variant => variant.option2)
    this.optionsSizes.forEach(selector => {
      if (!availableSizes.includes(selector.value)) {
        selector.classList.add('is-unavailable')
      } else {
        selector.classList.remove('is-unavailable')
      }
    })

    // if (availableSizes.length > 0) {
    //   const sizeRadio = [...this.optionsSizes].find(radio => radio.value === availableSizes[0])
    //   if (sizeRadio) {
    //     sizeRadio.checked = true
    //   }
    // }

    const variant = this.findVariant(selectorColor, selectorSize)
    if (variant.available) {
      this.querySelector('.btn-add-to-cart-sticky').classList.remove('soldOut-text')
      this.querySelector('.btn-add-to-cart-sticky').removeAttribute('disabled')
      this.querySelector('.btn-add-to-cart-sticky').textContent = theme.strings.products_product_add_to_cart
      this.inputVariantId.setAttribute('value', variant.id)
    } else {
      this.querySelector('.btn-add-to-cart-sticky').classList.add('soldOut-text')
      this.querySelector('.btn-add-to-cart-sticky').setAttribute('disabled', true)
      this.querySelector('.btn-add-to-cart-sticky').textContent = theme.strings.products_variant_no_stock
    }
  }

  autoSelectAvailableOptions() {
    const firstAvailableVariant = this.variants.find(variant => variant.available)
    if (firstAvailableVariant) {
      const { option1: firstAvailableColor, option2: firstAvailableSize } = firstAvailableVariant
      const colorRadio = [...this.optionsColors].find(radio => radio.value === firstAvailableColor)
      if (colorRadio) {
        colorRadio.checked = true
      }
      this.updateSizeOptions();
      const sizeRadio = [...this.optionsSizes].find(radio => radio.value === firstAvailableSize);
      if (sizeRadio) {
        sizeRadio.checked = true;
      }
      // this.checkSelection();
    }
  }

  handleActiveVariant() {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const urlVariantId = urlParams.get('variant')

    if (urlVariantId) {
      const optionsColors = document.querySelectorAll('.product__sticky .option-selector--swatch input[type="radio"]')
      const optionsSizes = document.querySelectorAll('.product__sticky .option-selector:not(.option-selector--swatch) input[type="radio"]')
      const selectedVariant = this.variants.find(variant => parseInt(variant.id) === parseInt(urlVariantId))

      if (selectedVariant) {
        const { option1: firstAvailableColor, option2: firstAvailableSize } = selectedVariant

        const colorRadio = [...optionsColors].find(radio => radio.value === firstAvailableColor)
        if (colorRadio) {
          colorRadio.checked = true
          // colorRadio.nextElementSibling.click()
        }

        const sizeRadio = [...optionsSizes].find(radio => radio.value === firstAvailableSize);
        if (sizeRadio) {
          sizeRadio.checked = true;
        }

        this.inputVariantId.setAttribute('value', selectedVariant.id)
      }
    }
  }

  findVariant(color, size) {
    return this.variants.find(v => {
      if (v.option1.toString() === color.toString() && v.option2.toString() === size.toString()) {
        return v
      }
    })
  }
}

customElements.define('product-sticky-custom', ProductStickyCustom)

// Custom button add to cart sticky
const btnAddToCartSticky = document.querySelector('.product__sticky .btn-add-to-cart-sticky')
if (btnAddToCartSticky) {
  btnAddToCartSticky.addEventListener('click', async function () {
    if (btnAddToCartSticky.classList.contains('soldOut-text')) return

    if (window.innerWidth < 768) {
      document.querySelector('.form.product-purchase-form .quantity-submit-row button[type="submit"]').click()
    } else {
      const productData = JSON.parse(btnAddToCartSticky.closest('.product__sticky').querySelector('script[type="application/json"]').textContent)
      const stickColor = document.querySelector('.product__sticky .option-selector--swatch .variant-image__option input[type="radio"]:checked').value
      const stickSize = document.querySelector('.product__sticky .option-selector--size input[type="radio"]:checked').value
      const variant = productData.variants.find(v => {
        if (v.option1.toString() === stickColor.toString() && v.option2.toString() === stickSize.toString()) {
          return v
        }
      })
      const data = {
        items: [
          {
            id: variant.id,
            quantity: 1,
          },
        ],
      }

      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      })
        .then(response => {
          openMiniCart()

          // if template is collection
          if (document.body.classList.contains('template-collection')) {
            button.closest('.quickbuy-toggle__mobile').classList.add('hidden')
            button.closest('.block-inner').querySelector('.quick-buy__icon').classList.remove('hidden')
          }
        })
        .catch((error) => {
          console.error('Error:', error)
          // alert('Error adding product to cart')
        })
    }
  })
}

const addToCartButtons = document.querySelectorAll('.add-to-cart__block');
const elmNotifyMessage = document.querySelector('.notify-add-cart-successfully')
if (addToCartButtons.length > 0) {
  addToCartButtons.forEach((button) => {
    button.addEventListener('click', async function () {
      const variantId = this.getAttribute('data-variant')
      const data = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      };

      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      })
        .then(response => {
          openMiniCart()

          // if template is collection
          if (document.body.classList.contains('template-collection')) {
            button.closest('.quickbuy-toggle__mobile').classList.add('hidden')
            button.closest('.block-inner').querySelector('.quick-buy__icon').classList.remove('hidden')
          }
        })
        .catch((error) => {
          console.error('Error:', error)
          // alert('Error adding product to cart')
        })
    })
  })
}

/**
 * Function minicart
 * 
 */
const minicartWrapper = document.querySelector('.mini-cart-wrapper');
const elmBody = document.querySelector('body');
const minicartLoading = document.querySelector('.mini-cart-content #mincart-loading');
const minicartCount = document.querySelector('#minicart-count');

// Close minicart
const closeIcon = document.querySelector('#close-minicart');
if (closeIcon) {
  closeIcon.addEventListener('click', function (e) {
    e.preventDefault();
    minicartWrapper.classList.remove('show')
    elmBody.classList.remove('open-minicart')

    document.documentElement.classList.remove('open-minicart')
  });
}

function listCartChange() {
  const listP = document.getElementById('minicart-product-list');
  const miniCartContainer = document.getElementById('mini-list');
  if (listP && miniCartContainer) {
    miniCartContainer.appendChild(listP);
    minicartWrapper.classList.add('added-list');
  }
}

function refreshMiniCart() {
  fetch('/cart').then(function (response) {
    // When the page is loaded convert it to text
    return response.text()
  })
    .then(function (html) {
      // Initialize the DOM parser
      const parser = new DOMParser();

      // Parse the text
      const doc = parser.parseFromString(html, 'text/html');

      if (elmBody.classList.contains('template-cart')) {
        const contentCartHtml = doc.querySelector('#cart-template').innerHTML;
        const cartCount = parseInt(doc.querySelector('#minicart-count').getAttribute('data-count'));
        const minicartTemplate = document.querySelector('#cart-template');

        if (cartCount === 0) {
          minicartTemplate.className = 'flex items-center justify-center max-w-7xl mx-auto px-4 py-10 md:py-[120px] h-full border-b border-border-default';
        } else {
          minicartTemplate.className = 'bg-white';
        }
        minicartTemplate.innerHTML = contentCartHtml;
        minicartLoading.style.display = 'none';
      }

      getElementMiniCart(doc);
      miniCartChange();
    })
    .catch(() => minicartLoading.style.display = 'none');
}

function miniCartChange() {
  // Close minicart
  const cartOverley = document.querySelector('#bg-minicart-close');
  if (cartOverley) {
    cartOverley.addEventListener('click', function (e) {
      e.preventDefault();
      minicartWrapper.classList.remove('show');
      elmBody.classList.remove('open-minicart')

      document.documentElement.classList.remove('open-minicart')
    });
  }

  const closeIcon = document.querySelector('#close-minicart');
  if (closeIcon) {
    closeIcon.addEventListener('click', function (e) {
      e.preventDefault();
      minicartWrapper.classList.remove('show')
      elmBody.classList.remove('open-minicart')

      document.documentElement.classList.remove('open-minicart')
    });
  }

  //remove
  Array.from(document.querySelectorAll('.cart-details .remove-item .delete')).forEach(function (ele) {
    ele.addEventListener('click', function (e) {
      e.preventDefault();
      let target = ele;
      let id = target.getAttribute('data-cart-item');
      if (id) {
        minicartLoading.style.display = 'block';
        removeItemById(id);
      }
    })
  });

  // udpate cart item
  Array.from(document.querySelectorAll('.cart-item__quantity-input')).forEach(function (ele) {
    ele.addEventListener('change', function (e) {
      e.preventDefault();
      let target = ele;
      let id = target.closest('.product-form-item').getAttribute('data-id');
      let qty = target.value;
      if (id && qty) {
        minicartLoading.style.display = 'block';
        updateItem(id, qty);
      }
    });
  });
}

function updateItem(id, qty) {
  if (!qty) {
    return removeItem(id)
  }

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: id,
      quantity: qty
    })
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((e) => console.error(e))
}

//change cart layout after refresh cart 
function getElementMiniCart(doc) {
  const minicartActions = document.querySelector('#minicart-actions');
  const minicartItems = document.querySelector('#minicart-items');
  const minicartContent = document.querySelector('.mini-cart-content');
  const minicartHeading = document.querySelector('#cart-heading');
  const cartSumarycontentCartHtml = doc.querySelector('#cart-summary-header')?.innerHTML;

  if (cartSumarycontentCartHtml && document.querySelector('#cart-summary-header')) {
    document.querySelector('#cart-summary-header').innerHTML = cartSumarycontentCartHtml;
  }

  if (doc.getElementById('minicart-count')) {
    const cartCount = parseInt(doc.querySelector('#minicart-count').getAttribute('data-count'));
    if (cartCount === 0) {
      minicartActions.classList.add('hidden');
      minicartContent.classList.add('no-item');
    } else {
      minicartCount.setAttribute('data-count', cartCount);
      minicartCount.textContent = cartCount;
      minicartContent.classList.remove('no-item');
      minicartActions.classList.remove('hidden');
    }
  }

  const headingCartHtml = doc.querySelector('#cart-heading').innerHTML;
  const contentCartHtml = doc.querySelector('#minicart-items').innerHTML;
  const actionCartHtml = doc.querySelector('#minicart-actions').innerHTML;

  if (contentCartHtml && headingCartHtml) {
    minicartHeading.innerHTML = headingCartHtml;
    minicartItems.innerHTML = contentCartHtml;
    minicartActions.innerHTML = actionCartHtml;
  }
  minicartLoading.style.display = 'none';
}

function openMiniCart() {
  refreshMiniCart()
  if (minicartWrapper.classList.contains('show')) {
    elmBody.classList.remove('open-minicart')
    document.documentElement.classList.remove('open-minicart')

    // stop scroll product thumbs
    if (document.body.classList.contains('template-product')) {
      document.querySelector('.horizontal--slick').classList.remove('open-minicart')
    }

    minicartWrapper.classList.remove('show')
  } else {
    minicartLoading.style.display = 'block';

    elmBody.classList.add('open-minicart')
    document.documentElement.classList.add('open-minicart')
    // stop scroll product thumbs
    if (document.body.classList.contains('template-product')) {
      document.querySelector('.horizontal--slick').classList.add('open-minicart')
    }

    minicartWrapper.classList.toggle('show')

    refreshMiniCart()
  }

  if (!minicartWrapper.classList.contains('added-list')) {
    listCartChange();
  }
}

miniCartChange()

if (document.querySelector('.btn-trigger-open-mini-cart')) {
  document.querySelector('.btn-trigger-open-mini-cart').addEventListener('click', () => {
    openMiniCart()
  })
}

// handle submit product form on product page
const forms = document.querySelectorAll('.template-product .form.product-purchase-form')
if (forms.length > 0) {
  const shopifyAjaxAddURL = theme.routes.cart_add_url + '.js';
  forms.forEach(form => {
    form.addEventListener('submit', function (event) {
      event.preventDefault()
      const elementId = form.querySelector('select')
      const elementQuantity = form.querySelector('input[name="quantity"]')
      const dataId = elementId.value
      const dataValue = elementQuantity.value

      let formData = {
        'items': [
          {
            'id': dataId,
            'quantity': dataValue || 1
          }
        ]
      }

      fetch(shopifyAjaxAddURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          document.querySelector('.btn-trigger-open-mini-cart').click()
        })
        .catch(error => {
          console.error(error)
        })

      return false
    })
  })
}

// handle product card
const productCards = document.querySelectorAll('.product-card--swiper')
productCards.forEach(productCard => {
  initSwiperMedia(productCard)
})

handlePaginationCustom()

const targetDiv = document.querySelector('.filter-container--side')
const observerCallback = function (mutationsList, observer) {
  mutationsList.forEach(function (mutation) {
    if (mutation.type === 'childList') {
      const productCards = document.querySelectorAll('.product-card--swiper')
      productCards.forEach(productCard => {
        initSwiperMedia(productCard)
        handlePaginationCustom()
      })
    }
  })
}

const observerOptions = {
  childList: true,
  attributes: false,
  subtree: false,
  characterData: false
};

const observer = new MutationObserver(observerCallback)
if (targetDiv) {
  observer.observe(targetDiv, observerOptions)
}

function handlePaginationCustom() {
  const paginationContainerFather = document.querySelectorAll(`.custom-pagination`)
  if (paginationContainerFather.length === 0) return

  paginationContainerFather.forEach((paginationContainer) => {
    const bullets = paginationContainer.querySelectorAll('.swiper-pagination-bullet')

    if (bullets.length > 0) {
      bullets[0].classList.add('swiper-pagination-bullet-active')

      // handle init swatch
      const defaultDataColor = bullets[0].getAttribute('data-swatch-name')
      console.log('dafaultCOlor', defaultDataColor)
      const defaultSwiperSlides = paginationContainer.closest('.product-block').querySelectorAll('.product-card--swiper-slide.swiper-slide')
      defaultSwiperSlides.forEach(function (slide) {
        if (slide.getAttribute('data-variant-image-group') !== defaultDataColor) {
          slide.classList.add('non-swiper-slide')
          slide.classList.remove('swiper-slide')
          slide.style.display = 'none'

        }
      });

      const matchingSlides = paginationContainer.closest('.product-block').querySelectorAll(".product-card--swiper-slide[data-variant-image-group='" + defaultDataColor + "']")
      matchingSlides.forEach(function (slide) {
        slide.classList.remove('non-swiper-slide')
        slide.classList.add('swiper-slide')
        slide.removeAttribute('style')
        slide.style.display = 'block'
      })

      // handle init size
      handleDisplaySize(null, defaultDataColor, paginationContainer)

      // handle click on other color
      paginationContainer.addEventListener('click', function (event) {
        const dataColor = event.target.getAttribute('data-swatch-name')
        const targetBullet = event.target.closest('.swiper-pagination-bullet')
        const elmProductBlock = paginationContainer.closest('.product-block')

        // Only apply on product page and section complete the look
        if (paginationContainer.closest('.hoko-complementary')) {
          const itemSTL = paginationContainer.closest('.hoko-complementary__detail')
          if (itemSTL.querySelectorAll('.hoko-complementary__list .product-card--swiper-slide-stl').length > 0) {
            Array.from(itemSTL.querySelectorAll('.hoko-complementary__list .product-card--swiper-slide-stl')).forEach(slide => {
              slide.style.display = 'none'
            })
          }

          if (itemSTL.querySelector(`.hoko-complementary__list .product-card--swiper-slide-stl[data-image-color="${dataColor}"]`)) {
            itemSTL.querySelector(`.hoko-complementary__list .product-card--swiper-slide-stl[data-image-color="${dataColor}"]`).style.display = 'block'
          }
        }

        if (targetBullet) {
          bullets.forEach((bullet) => {
            bullet.classList.remove('swiper-pagination-bullet-active')
          })

          targetBullet.classList.add('swiper-pagination-bullet-active')
        }

        // handle init swatch after click
        const swiperSlides = targetBullet?.closest('.product-block').querySelectorAll('.product-card--swiper-slide.swiper-slide')
        if (swiperSlides.length > 0) {
          swiperSlides.forEach(function (slide) {
            if (slide.getAttribute('data-variant-image-group') !== dataColor) {
              slide.classList.add('non-swiper-slide')
              slide.classList.remove('swiper-slide')
              slide.style.display = 'none'

            }
          })
        }

        const matchingSlides = elmProductBlock?.closest('.product-block').querySelectorAll(".product-card--swiper-slide[data-variant-image-group='" + dataColor + "']")
        if (matchingSlides.length > 0) {
          matchingSlides.forEach(function (slide) {
            slide.classList.remove('non-swiper-slide')
            slide.classList.add('swiper-slide')
            slide.removeAttribute('style')
            slide.style.display = 'block'
          })
        }

        // reinit swiper
        const swiper = new Swiper(elmProductBlock.closest('.product-block').querySelector('.product-card--swiper .swiper'), {
          initialSlide: 0,
          slidesPerView: 1,
          slidesPerColumn: 1,
          paginationClickable: true,
          spaceBetween: 0,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: elmProductBlock.closest('.product-block').querySelector('.swiper-button-next'),
            prevEl: elmProductBlock.closest('.product-block').querySelector('.swiper-button-prev'),
          },
          // pagination: {
          //   el: elmProductBlock.closest('.product-block').querySelector('.product-card--swiper-pagination'),
          //   clickable: true
          // }
        })
        swiper.update()

        if (Array.from(elmProductBlock.closest('.product-block').querySelectorAll('.product-card--swiper-pagination .swiper-pagination-bullet')).length > 0) {
          Array.from(elmProductBlock.closest('.product-block').querySelectorAll('.product-card--swiper-pagination .swiper-pagination-bullet')).forEach(b => {
            b.classList.remove('swiper-pagination-bullet-active')
          })
        }

        if (elmProductBlock.closest('.product-block').querySelectorAll('.product-card--swiper-pagination .swiper-pagination-bullet').length > 0) {
          elmProductBlock.closest('.product-block').querySelectorAll('.product-card--swiper-pagination .swiper-pagination-bullet')[0].classList.add('swiper-pagination-bullet-active')
        }

        handleDisplaySize(targetBullet, dataColor, null)
      })
    }
  })
}

function handleDisplaySize(targetBullet, dataColor, paginationContainer) {
  let elmSizes = []
  if (targetBullet) {
    elmSizes = targetBullet.closest('.product-block').querySelectorAll('.quickbuy-toggle__mobile .add-to-cart--size')
  } else if (paginationContainer) {
    elmSizes = paginationContainer.closest('.product-block').querySelectorAll('.quickbuy-toggle__mobile .add-to-cart--size')
  }

  elmSizes.forEach(function (size) {

    if (size.getAttribute('data-variant-image-group') !== dataColor) {
      size.classList.add('non-swiper-slide')
      size.style.display = 'none'
    } else {
      size.classList.remove('non-swiper-slide')
      size.style.display = 'block'
    }

  })
}

function initSwiperMedia(productCard) {
  const GROUPING_OPTION_INDEX = 0
  const dataJSON = JSON.parse(productCard.closest('.product-block').querySelector('script[type="application/json"]').textContent)
  if (!dataJSON) return

  // build map of grouping options and featured media
  let optionNameMediaMap = {};
  dataJSON.variants.forEach(variant => {
    if (variant.featured_media) {
      if (!optionNameMediaMap[variant.options[GROUPING_OPTION_INDEX]]) {
        optionNameMediaMap[variant.options[GROUPING_OPTION_INDEX]] = variant.featured_media.id;
      }
    }
  })

  let currentMediaOptionName = '';
  Array.from(productCard.querySelectorAll('.product-card--swiper .product-card--swiper-slide')).forEach((item, index) => {
    for (const optionName in optionNameMediaMap) {
      if (parseInt(item.getAttribute('data-media-id')) === parseInt(optionNameMediaMap[optionName])) {
        currentMediaOptionName = optionName
      }
    }
    item.setAttribute('data-variant-image-group', currentMediaOptionName)
  })

  // init swiper
  let swiper = new Swiper(productCard.querySelector('.swiper'), {
    loop: false,
    spaceBetween: 0,
    slidesPerView: 1,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: productCard?.querySelector('.swiper-button-next'),
      prevEl: productCard?.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: productCard?.querySelector('.product-card--swiper-pagination'),
      clickable: true
    }
  })
}

class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.initGrid();
    this.init();
    this.page = 1;
    this.initNumberPerPage = 0;
    this.numberPerPage = this.dataset.numberPerPage;
  }
  initGrid() {
    const gridOptions = ['.ProductListWrapper', '#main-collection-product-grid', '#product-grid', '.product-list'];
    for (let gridName of gridOptions) {
      let grid = document.querySelector(gridName);
      if (grid) {
        this.gridName = gridName;
        this.gridContainer = grid;
        break;
      }
    }
  }
  init() {
    const observer = new IntersectionObserver(this.revealItem.bind(this), {
      root: null,
      threshold: 0.05,
    });
    observer.observe(this);
  }
  fetchNextPage(e) {
    if (e <= this.dataset.pageSize) {
      const t = `${theme.routes.shop_url}/${this.dataset.next}`;
      const i = new URL(t);
      i.searchParams.set('page', e);
      i.searchParams.delete('phcursor');
      const r = i.href;
      fetch(`${r}`, { method: 'GET', headers: { 'Content-Type': 'text/html' } })
        .then((e) => e.text())
        .then((e) => {
          const t = new DOMParser().parseFromString(e, 'text/html');
          const i = t.querySelector(this.gridName).innerHTML;
          this.gridContainer.insertAdjacentHTML('beforeend', i);

          this.reInitEventOnCart()
          this.reInitSwiperProductCard();
        })
        .catch((e) => {
          console.error('Error:', e);
        });
    }
    if (e == this.dataset.pageSize) {
      this.innerHTML = `<h2>${this.dataset.endText}</h2>`;
    }
  }
  revealItem(e, t) {
    const [i] = e;
    if (!i.isIntersecting) return;
    if (i.target) {
      this.page++;
      this.fetchNextPage(this.page);
    }
    if (this.page == this.dataset.pageSize) {
      t.unobserve(i.target);
    }
    this.initNumberPerPage = parseInt(this.initNumberPerPage) + parseInt(this.numberPerPage);
  }

  reInitSwiperProductCard() {
    const swipers = document.querySelectorAll('.product-card--swiper');
    Array.from(swipers)
      .slice(this.initNumberPerPage)
      .forEach((section) => {
        this.initSwiperMedia(section);
      });

    // Seleccionar todos los íconos de compra rápida
    const quickBuyButtons = document.querySelectorAll('.quick-buy__icon');

    quickBuyButtons.forEach((quickBuy) => {
      quickBuy.addEventListener('click', (event) => {
        event.stopPropagation(); // Detener la propagación del evento
        quickBuy.classList.add('hidden');
        // Buscar el contenedor .swiper-slide
        // let swiperSlide = quickBuy.closest('.swiper-slide');
        let swiperSlide = quickBuy.closest('.block-inner') || quickBuy.closest('.swiper-slide');
        if (swiperSlide) {
          let quickBuyToggle = swiperSlide.querySelector('.quickbuy-toggle__mobile');
          if (quickBuyToggle) {
            quickBuyToggle.classList.remove('hidden');
          }
        }
      });
    });

    this.handlePaginationCustom();
  }

  reInitEventOnCart() {
    const addToCartButtons = document.querySelectorAll('.add-to-cart__block');
    if (addToCartButtons.length > 0) {
      addToCartButtons.forEach((button) => {
        button.addEventListener('click', async () => {
          const variantId = button.getAttribute('data-variant');
          const data = {
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          };

          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
            .then((response) => {

              openMiniCart()
              // this.openMiniCart()
            })
            .catch((error) => {
              console.error('Error:', error);
              // alert('Error adding product to cart');
            });
        });
      });
    }
  }

  initSwiperMedia(productCard) {
    const GROUPING_OPTION_INDEX = 0;
    const dataJSON = JSON.parse(
      productCard.closest('.product-block').querySelector('script[type="application/json"]').textContent
    );
    if (!dataJSON) return;

    // build map of grouping options and featured media
    let optionNameMediaMap = {};
    dataJSON.variants.forEach((variant) => {
      if (variant.featured_media) {
        if (!optionNameMediaMap[variant.options[GROUPING_OPTION_INDEX]]) {
          optionNameMediaMap[variant.options[GROUPING_OPTION_INDEX]] = variant.featured_media.id;
        }
      }
    });

    let currentMediaOptionName = '';
    Array.from(productCard.querySelectorAll('.product-card--swiper .product-card--swiper-slide')).forEach(
      (item, index) => {
        for (const optionName in optionNameMediaMap) {
          if (parseInt(item.getAttribute('data-media-id')) === parseInt(optionNameMediaMap[optionName])) {
            currentMediaOptionName = optionName;
          }
        }
        item.setAttribute('data-variant-image-group', currentMediaOptionName);
      }
    );

    // init swiper
    let swiper = new Swiper(productCard.querySelector('.swiper'), {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 1,
      centeredSlides: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: productCard?.querySelector('.swiper-button-next'),
        prevEl: productCard?.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: productCard?.querySelector('.product-card--swiper-pagination'),
        clickable: true,
      },
    });
  }

  handlePaginationCustom() {
    const paginationContainerFather = document.querySelectorAll(`.custom-pagination`);
    if (paginationContainerFather.length === 0) return;

    paginationContainerFather.forEach((paginationContainer) => {
      const bullets = paginationContainer.querySelectorAll('.swiper-pagination-bullet');

      if (bullets.length > 0) {
        bullets[0].classList.add('swiper-pagination-bullet-active');

        // handle init swatch
        const defaultDataColor = bullets[0].getAttribute('data-swatch-name');
        const defaultSwiperSlides = paginationContainer
          .closest('.product-block')
          .querySelectorAll('.product-card--swiper-slide.swiper-slide');
        defaultSwiperSlides.forEach(function (slide) {
          if (slide.getAttribute('data-variant-image-group') !== defaultDataColor) {

            slide.classList.add('non-swiper-slide');
            slide.classList.remove('swiper-slide');
            slide.style.display = 'none';

          }
        });

        const matchingSlides = paginationContainer
          .closest('.product-block')
          .querySelectorAll(".product-card--swiper-slide[data-variant-image-group='" + defaultDataColor + "']");
        matchingSlides.forEach(function (slide) {
          slide.classList.remove('non-swiper-slide');
          slide.classList.add('swiper-slide');
          slide.removeAttribute('style');
          slide.style.display = 'block';
        });

        // handle init size
        this.handleDisplaySize(null, defaultDataColor, paginationContainer);

        // handle click on other color
        paginationContainer.addEventListener(
          'click',
          function (event) {
            const dataColor = event.target.getAttribute('data-swatch-name');
            const targetBullet = event.target.closest('.swiper-pagination-bullet');
            const elmProductBlock = paginationContainer.closest('.product-block');

            if (targetBullet) {
              bullets.forEach((bullet) => {
                bullet.classList.remove('swiper-pagination-bullet-active');
              });

              targetBullet.classList.add('swiper-pagination-bullet-active');
            }

            // handle init swatch after click
            const swiperSlides = targetBullet
              ?.closest('.product-block')
              .querySelectorAll('.product-card--swiper-slide.swiper-slide');

            if (swiperSlides.length > 0) {
              swiperSlides.forEach(function (slide) {
                if (slide.getAttribute('data-variant-image-group') !== dataColor) {
                  slide.classList.add('non-swiper-slide');
                  slide.classList.remove('swiper-slide');
                  slide.style.display = 'none';
                }
              });
            }

            const matchingSlides = elmProductBlock
              ?.closest('.product-block')
              .querySelectorAll(".product-card--swiper-slide[data-variant-image-group='" + dataColor + "']");

            if (matchingSlides.length > 0) {
              matchingSlides.forEach(function (slide) {
                slide.classList.remove('non-swiper-slide');
                slide.classList.add('swiper-slide');
                slide.removeAttribute('style');
                slide.style.display = 'block';
              });
            }

            // Reinitialize Swiper
            const swiper = new Swiper(elmProductBlock.closest('.product-block').querySelector('.product-card--swiper .swiper'), {
              initialSlide: 0,
              slidesPerView: 1,
              slidesPerColumn: 1,
              paginationClickable: true,
              spaceBetween: 0,
              mousewheel: {
                forceToAxis: true,
              },
              navigation: {
                nextEl: elmProductBlock.closest('.product-block').querySelector('.swiper-button-next'),
                prevEl: elmProductBlock.closest('.product-block').querySelector('.swiper-button-prev'),
              },
            });
            swiper.update();

            if (Array.from(elmProductBlock.closest('.product-block').querySelectorAll('.product-card--swiper-pagination .swiper-pagination-bullet')).length > 0) {
              Array.from(elmProductBlock.closest('.product-block').querySelectorAll('.product-card--swiper-pagination .swiper-pagination-bullet')).forEach(b => {
                b.classList.remove('swiper-pagination-bullet-active');
              });
            }

            if (elmProductBlock.closest('.product-block').querySelectorAll('.product-card--swiper-pagination .swiper-pagination-bullet').length > 0) {
              elmProductBlock.closest('.product-block').querySelectorAll('.product-card--swiper-pagination .swiper-pagination-bullet')[0].classList.add('swiper-pagination-bullet-active');
            }


            this.handleDisplaySize(targetBullet, dataColor, null);
          }.bind(this) // 👈 Aquí nos aseguramos de que "this" siga apuntando a la instancia de la clase
        );
      }
    })
  }

  handleDisplaySize(targetBullet, dataColor, paginationContainer) {
    let elmSizes = [];
    if (targetBullet) {
      elmSizes = targetBullet
        .closest('.product-block')
        .querySelectorAll('.quickbuy-toggle__mobile .add-to-cart--size');
    } else if (paginationContainer) {
      elmSizes = paginationContainer
        .closest('.product-block')
        .querySelectorAll('.quickbuy-toggle__mobile .add-to-cart--size');
    }

    elmSizes.forEach(function (size) {
      if (size.getAttribute('data-variant-image-group') !== dataColor) {

        size.classList.add('non-swiper-slide');
        size.style.display = 'none';

      } else {
        size.classList.remove('non-swiper-slide');
        size.style.display = 'block';
      }
    });
  }
}
customElements.define('infinite-scroll', InfiniteScroll);

function handleCustomizeHeader() {
  const elmHeroBanner = document.querySelector('.section-hoko-hero-banner .hoko-hero-banner')
  if (!elmHeroBanner) return

  const elmHeader = document.querySelector('.section-header')
  if (!elmHeader) return

  const typeHeaderAttr = elmHeroBanner.getAttribute('data-type-header')

  elmHeader.setAttribute('data-type-header', typeHeaderAttr)
}

handleCustomizeHeader()

const originalFetch = window.fetch;

window.fetch = async function (...args) {
  if (typeof args[0] === "string" && args[0].includes("/cart.js")) {
    const response = await originalFetch.apply(this, args);

    try {
      const clone = response.clone(); // clonamos porque solo se puede leer una vez
      const data = await clone.json();
      const itemCount = data.item_count;
      const badge = document.querySelector("#minicart-count");
      if (badge) badge.textContent = data.item_count;
    } catch (err) {
      console.error("Error leyendo cart.js:", err);
    }

    return response;
  }

  return originalFetch.apply(this, args);
};
